module.exports = __webpack_public_path__ + "static/media/box-arrow-up.845bc14e.svg";